module.exports = __webpack_public_path__ + "img/1.8ffc76ff.jpg";